<template>
  <div class="w-100">
    <div class="header">
      <h3>Nature des travaux</h3>
    </div>
    <div class="block-content">
      <div class="form-group">
        <b-row>
          <b-col xl="3" lg="4" md="5" sm="12" cols="12" class="no-padding">
            <label class="control-label"
              >Permission de voirie antérieure :</label
            >
          </b-col>
          <b-col xl="9" lg="8" md="7" sm="12" cols="12" class="marginTopSmall">
            <b-form-radio-group
              v-model="cerfa.previousPermission"
              :options="permissions"
            ></b-form-radio-group>
          </b-col>
          <b-col
            lg="12"
            md="12"
            sm="12"
            cols="12"
            class="no-padding"
            v-if="cerfa.previousPermission == true"
          >
            <b-row>
              <b-col xl="3" lg="3" md="5" sm="12" cols="12" class="no-padding">
                <label class="control-label"
                  >Si oui indiquer la référence :</label
                >
              </b-col>
              <b-col xl="9" lg="9" md="7" sm="12" cols="12">
                <b-form-input
                  v-model="cerfa.previousPermissionReference"
                  placeholder="Référence"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div class="form-group">
        <b-row>
          <b-col xl="3" lg="3" md="5" sm="12" cols="12" class="no-padding">
            <label class="control-label">Description des travaux :</label>
          </b-col>
          <b-col xl="9" lg="9" md="7" sm="12" cols="12">
            <b-form-textarea
              v-model="cerfa.workDescription"
              style="height:150px;"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "NatureTravauxD14024",
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14024"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14024"]),
    cerfa: {
      get: function() {
        return this.cerfa14024;
      },
      set: function(newValue) {
        this.setCerfa14024(newValue);
      },
    },
  },
  data() {
    return {
      permissions: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
    };
  },
};
</script>

<style scoped></style>
